import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DismissStartingScreenMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DismissStartingScreenMutation = { __typename: 'Mutation', dismissStartingScreen: { __typename: 'User', id: string, startingScreenDismissedAt?: string | null } };

export const DismissStartingScreenDocument = gql`
    mutation dismissStartingScreen {
  dismissStartingScreen {
    id
    startingScreenDismissedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DismissStartingScreenGQL extends Apollo.Mutation<DismissStartingScreenMutation, DismissStartingScreenMutationVariables> {
    override document = DismissStartingScreenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }